import { loginModuleQuery, useModule } from 'system/structure-modules';

export default function LoginFragmentRedirectScreen() {
    const { FragmentRedirectScreen } = useModule(loginModuleQuery);
    return <FragmentRedirectScreen />;
}
